jQuery.noConflict();

jQuery(document).ready(function () {

	// MAIN NAVIGATION DROPDOWN

	jQuery(".nav-main .menu-item-has-children")
		.mouseenter(function () {
			jQuery("> .sub-menu", this).stop().addClass("open").parent().addClass("active");
		})
		.mouseleave(function () {
			jQuery("> .sub-menu", this).stop().removeClass("open").parent().removeClass("active");
		});

	// MOBILE NAVIGATION

	jQuery(".trigger-nav-mobile").click(function () {

		if (jQuery(".nav-mobile").hasClass("open")) {
			jQuery(".trigger-nav-mobile, .nav-mobile").removeClass("open");
			jQuery(".nav-mobile .sub-menu").removeClass("shown");
			jQuery("body").removeClass("nav-mobile-active");
		} else {
			jQuery(".trigger-nav-mobile, .nav-mobile").addClass("open");
			jQuery("body").addClass("nav-mobile-active");
		}

	});

	// ACCORDION ON MOBILE NAVIGATION

	jQuery(".nav-mobile .menu-item-has-children > a").click(function (event) {

		event.preventDefault();

		var accordion_header = jQuery(this);

		var accordion_content = jQuery(accordion_header).next(".sub-menu");

		jQuery(accordion_header).toggleClass("active");

		jQuery(".nav-mobile .menu-item-has-children > a").not(accordion_header).removeClass("active");

		jQuery(accordion_content).toggle();

		jQuery(".nav-mobile .sub-menu").not(accordion_content).hide();

	});

	// WHO ANSWERS LIGHTBOX

	jQuery(".who_answers, .who-answers").click(function (e) {
    	jQuery("#who_answers").lightbox_me({
		centered: true,
		overlayCSS: { background: "black", opacity: 0.75 },
    });
    e.preventDefault();
  });

  // CTA GOOGLE EVENT TRIGGER

	jQuery("a[href^='tel']").on("click touch", function (e) {
		let name = "Not Set";
		if (undefined !== jQuery(this).data("name")) {
			name = jQuery(this).data("name");
		}
		gtag("event", e.type, {
			event_category: name,
			event_label: jQuery(document).attr("title"),
		});
	});

});